import { MenuItem, styled } from '@mui/material';
import { BiFolder } from 'react-icons/bi';
import { useImageContext } from '../../imageContext';

const UnselectedFolderElement = styled(MenuItem)({
  fontWeight: 'bold',
  backgroundColor: '#FFFFFF',
  height: '25px',
});

const SelectedFolderElement = styled(MenuItem)({
  fontWeight: 'bold',
  backgroundColor: '#D3D3D3',
  height: '25px',
});

export interface ImageFolderProps {
  item: string;
  readOnly: boolean | undefined
}

export const ImageFolder = (props: ImageFolderProps): JSX.Element => {
  const { itemList, setEmptyFolder, setFolder, selected, setSelected } =
    useImageContext();

  const handleClick = (): void => {
    if (selected === props.item) {
      setSelected('');
      setFolder('');
      setEmptyFolder(false);
    } else {
      setSelected(props.item);
      setFolder(props.item);
      const items = itemList.filter((item) => item.startsWith(props.item));
      setEmptyFolder(items.length <= 1);
    }
  };

  if (selected === props.item) {
    return (
      <SelectedFolderElement
        autoFocus={true}
        onClick={() => handleClick()}
        data-testid={`id-${props.item}`}
        key={`id-${props.item}`}
        disabled={props.readOnly}
      >
        <BiFolder /> {props.item}
      </SelectedFolderElement>
    );
  } else {
    return (
      <UnselectedFolderElement
        onClick={() => handleClick()}
        data-testid={`id-${props.item}`}
      >
        <BiFolder /> {props.item}
      </UnselectedFolderElement>
    );
  }
};
